"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SubHeader;
var _react = _interopRequireDefault(require("react"));
var _useTranslation = _interopRequireDefault(require("../../../hooks/useTranslation"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @ts-ignore: Unreachable code error

function SubHeader() {
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 8,
      bottom: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    justify: "center",
    noMargin: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "barring-management-subheader-text-1"
  }, t('subtitle'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    justify: "center",
    noMargin: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "barring-management-subheader-text-2"
  }, t('subtitle2'))));
}